import styled from 'styled-components';
import { Button, Menu } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledMenu = styled(Menu)`
  width: 100%;
  background: transparent !important;

  &&& .ant-menu-item.ant-menu-item-selected {
    font-weight: 600;

    &::after {
      border-bottom-color: ${COLORS.YELLOW_PRIMARY} !important;
    }
  }

  &&& .ant-menu-item.ant-menu-item-active::after {
    &::after {
      border-bottom-color: ${COLORS.YELLOW_PRIMARY} !important;
    }
  }
`;

export const StyledTextButton = styled(Button)`
  &&& {
    background: transparent;
    border: none;
    max-height: 1.5rem;
    text-transform: uppercase;
    line-height: 1;
    padding: 0;
    border: none;
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
    color: ${COLORS.CHARCOAL};
  }

  &&& svg {
    transform: rotate(90deg);
    fill: ${COLORS.CHARCOAL};
  }

  &&&:hover {
    background: transparent;
    border: none;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 6rem;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY};
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;
